import workspaceQuery from '../../queries/diary/EventGlobalAmendResultsWorkspaceQuery.graphql';
import instanceQuery from '../../queries/diary/EventGlobalAmendQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const DiaryGlobalAmendResult: EntityType = {
  type: 'EventGlobalAmendResult',
  title: 'Diary Global Amendment Results',
  formTitle: 'Diary Global Amendment Result',
  workspaceUrl: '/Diary/DiaryGlobalAmendResultDetails/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  screenReference: 'DIARY_GLOBAL_AMENDMENTS',
};

export default DiaryGlobalAmendResult;
